import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthContext";
import { Alert } from "reactstrap";


const Subscribe = () => {
    const { user, loading, login, isSubscriber, getCurrentUser } = useAuth();

    useEffect(() => {
        if(!loading && user)
        {
            console.log("Hello");
        }
    }, []);

    return (
      <div>
        <div className="container mt-5">
          {/*  */}
          {/* <Alert color="primary" className="row justify-content-center">Continue your subscription</Alert> */}
          {/* <h1 className="text-center mb-4">Choose Your Subscription Plan</h1> */}
          <h1 className="text-center mb-4"> Resume your subscription</h1>
          <p className="row justify-content-center">Looks like your subscription plan has expired please choose a plan below:</p>
          <div className="row justify-content-center">
            <div className="col-md-4 mb-4">
              <div className="card h-100 shadow">
                <div className="card-body text-center">
                  <h3 className="card-title">Monthly Plan</h3>
                  <h2 className="card-text my-4">$10<small>/month</small></h2>
                  <ul className="list-unstyled">
                    <li className="mb-2">Full Access to All Features</li>
                    <li className="mb-2">Detailed Statistics</li>
                    <li className="mb-2">Performance Tracking</li>
                  </ul>
                  <button className="btn btn-primary btn-lg mt-3">Subscribe Monthly</button>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100 shadow border-primary">
                <div className="card-body text-center">
                  <h3 className="card-title">Annual Plan</h3>
                  <h2 className="card-text my-4">$100<small>/year</small></h2>
                  <div className="badge bg-success mb-3">Save $20!</div>
                  <ul className="list-unstyled">
                    <li className="mb-2">All Monthly Plan Features</li>
                    <li className="mb-2">Two Months Free</li>
                    <li className="mb-2">Priority Support</li>
                  </ul>
                  <button className="btn btn-primary btn-lg mt-3">Subscribe Yearly</button>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100 shadow border-success">
                <div className="card-body text-center">
                  <h3 className="card-title">Team Plan</h3>
                  <h2 className="card-text my-4">$100<small>/player/year</small></h2>
                  <div className="badge bg-success mb-3">Coach Access Free!</div>
                  <ul className="list-unstyled">
                    <li className="mb-2">All Annual Plan Features</li>
                    <li className="mb-2">Team Management Tools</li>
                    <li className="mb-2">Coach Dashboard</li>
                    <li className="mb-2">Team Analytics</li>
                  </ul>
                  <button className="btn btn-success btn-lg mt-3">Get Team Access</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Subscribe;
